import React from "react";
import "./style.scss";

interface RadioButtonProps {
  label: React.ReactNode;
  name: string;
  value: string;
  checked: boolean;
  onChange: (event: React.ChangeEvent<HTMLInputElement>) => void;
  disabled?: boolean;
}

const RadioButton: React.FC<RadioButtonProps> = ({
  label,
  name,
  value,
  checked,
  onChange,
  disabled = false,
}) => {
  const id = `radio-${name}-${value}`;
  return (
    <div className="radio-button-wrapper">
      <input
        type="radio"
        id={id}
        name={name}
        value={value}
        checked={checked}
        onChange={onChange}
        disabled={disabled}
      />
      <label htmlFor={id} className="radio-button-label">
        {label}
      </label>
    </div>
  );
};

export default RadioButton;
